import { createApi, fetchData, deleteApi, getApi, updateApi, uploadApi } from '@/lib/api.service.js'

const currentUrl = `${import.meta.env.VITE_BACKEND_URL}/api/v2/servicechek/us_states`;

export async function indexUsStates(params = null) {
  try {
    return await fetchData(currentUrl, params);
  } catch (e) {
    console.error(e);
    throw e;
  }
}

export async function getUsState(id){
  try {
    let url = `${currentUrl}/${id}`;
    const response = await getApi(url);

    if (response.status >= 200 && response.status < 300) {
      return response.json
    } else {
      throw new Error(response.json.error);
    }
  } catch (e) {
    console.error(e);
    throw e;
  }
}

export async function createUsState(data) {
  data = { us_state: data };

  try {
    const response = await createApi(currentUrl, data);

    if (response.status >= 200 && response.status < 300) {
      return response.json
    } else {
      throw new Error(response.json.error);
    }
  } catch (e) {
    console.error(e);
    throw e;
  }
}

export async function updateUsState(id, data) {
  data = { us_state: data };

  try {
    let url = `${currentUrl}/${id}`;
    const response = await updateApi(url, data);

    if (response.status >= 200 && response.status < 300) {
      return response.json
    } else {
      throw new Error(response.json.error);
    }
  } catch (e) {
    console.error(e);
    throw e;
  }
}